import React from "react";

export const VariableDisplay = ({ label, value, marginBottom, boldValueText = true }) => {
  return (
    <div className={`variableDisplay${marginBottom ? ' marginBottom' : ''}`}>
      <span className="small">{label}</span>
      <span className={boldValueText ? "bold" : ""}>{value}</span>
    </div>
  )
}